import { useTranslation } from 'next-i18next'
import { SyntheticEvent } from 'react'

import ROUTES from '~/shared/constants/routes.const'
import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'
import { WIND_SURFER } from '~/statistics/constants'
import { convertMsToDayHourMinute } from '~/user-stats/utility/date.utils'

import TimeSpent from '../TimeSpent'
import SummaryHeader from '../SummaryHeader'

interface Props {
  showContent: boolean
  onClick: () => void
  timeSpent: number
}

export default function StackNLoadSummary({ showContent, onClick, timeSpent }: Props): React.ReactElement {
  const { t } = useTranslation('statistics')
  const { days, hours, minutes } = convertMsToDayHourMinute(timeSpent)

  const onClickTitle = (evt: SyntheticEvent): void => {
    evt.stopPropagation()
    statisticsAnalytics.logProductTileClick({ title: WIND_SURFER })
  }

  return (
    <button className="w-full space-y-3" onClick={onClick}>
      <SummaryHeader
        cardTitle={WIND_SURFER}
        iconAltText={WIND_SURFER}
        iconSrcKey="scoreboard/WindSurfer.png"
        onClickTitle={onClickTitle}
        productHref={ROUTES.WINDSURFER}
        productSubtitle="Division"
        productTitle={t('game')}
        showContent={showContent}
      />
      <div className="font-medium flex flex-start">
        <TimeSpent days={days} hours={hours} minutes={minutes} />
      </div>
    </button>
  )
}
